import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, of } from 'rxjs';

export const newsManagementGuard: CanActivateFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.getPayloadFromAccessToken().pipe(
    map((payload) => {
      const correctRole = payload.role.includes('Admin') || payload.role.includes('Marketing');
      if (!correctRole) {
        router.navigate(['split-view/apartment-selection']);
        return false;
      }
      return correctRole;
    }),
    catchError((error) => {
      console.error(error);
      router.navigate(['split-view/apartment-selection']);
      return of(false);
    })
  );
};
